
import React from "react";
const IMAGE_URL = 'https://paralight-9bf8e.web.app/images/cashappImage.png'

const HowItWorks = () => (
  <section style={styles.section}>
    <details style={styles.details}>
      <summary style={styles.summary}>How to Get Started</summary>
      <ol style={styles.list}>
        <li>Install the Downloader app on your device.</li>
        <li>Open the Downloader app - Type in paralighttv.net into the URL box - Press "Download Now" from the ParalightTV website.</li>
        <li>Send $10 via CashApp to ** <span style={{ color: "#018ae0", fontWeight: "bold" }}>$paralight </span>** with your email in the notes section.</li>
        <li>Receive login credentials within 10 minutes. </li>
      </ol>
    </details>

    <details style={styles.details}>
        <summary style={styles.summary}>How to Pay</summary>
        <p>
            Send your payment via Cash App to $paralight and  <span style={{ color: "#018ae0", fontWeight: "bold" }}>BE SURE TO ADD YOUR USER EMAIL TO THE NOTES SECTION OF CASH APP</span>.
            **If this last step is forgotten screen shot proof of payment and email us at paralight811@gmail.com**
        </p>
        <div className="imageContainer">
            <img src={IMAGE_URL} alt="Paralight Logo"  style={styles.image} />
        </div>
    </details>
    <details style={styles.details}>
      <summary style={styles.summary}>Can I watch TV on multiple devices at the same time?</summary>
      <p>YES! You can have  <span style={{ color: "#018ae0", fontWeight: "bold" }}>up to 4 devices on your account</span> and all can stream simultaneously.</p>
    </details>
    <details style={styles.details}>
      <summary style={styles.summary}>Can i watch Paralight TV on my phone?</summary>
      <p>YES! But <span style={{ color: "#018ae0", fontWeight: "bold" }}>only if you phone is a Android</span>. Paralight TV does not work for iPhones  </p>
    </details>
    <details style={styles.details}>
  <summary style={styles.summary}>Having trouble downloading Paralight?</summary>
  <p>No problem — watch this tutorial!</p>
  <video
    controls
    style={{ width: "100%", maxWidth: "600px", marginTop: "1rem", borderRadius: "8px" }}
  >
    <source
      src="https://firebasestorage.googleapis.com/v0/b/paralight-9bf8e.firebasestorage.app/o/paralightInstallDemo.mov?alt=media&token=b423688e-ac9a-40d9-b461-e9e1ab61e53a"
      type="video/mp4"
    />
    Your browser does not support the video tag.
  </video>
</details>

    <details style={styles.details}>
        <summary style={styles.summary}>How do i report a issue</summary>
        <p>
            Please contact us via email at{" "}
            <a href="mailto:paralight811@gmail.com" style={styles.link}>
            paralight811@gmail.com
            </a>
        </p>
    </details>
    
  </section>
);

export default HowItWorks;

const styles = {
    section: {
      padding: "2rem",
      backgroundColor: "#1a1a1a",
      color: "#fff",
      borderRadius: "10px",
      margin: "2rem 0",
    },
    details: {
      backgroundColor: "#2a2a2a",
      borderRadius: "8px",
      marginBottom: "1rem",
      padding: "1rem",
      cursor: "pointer",
    },
    summary: {
      fontWeight: "bold",
      fontSize: "1.2rem",
      marginBottom: "0.5rem",
    },
    list: {
      paddingLeft: "1.5rem",
      fontSize: "1rem",
      lineHeight: "1.6",
      marginTop: "0.5rem",
    },
    image: {
        maxWidth: "100%",
        height: "auto",
        maxHeight: "300px", // ← Adjust size here
        display: "block",
        margin: "0 auto",
        objectFit: "contain",
    },
      
    
  };
  